<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_4"></a><em>For Evelyn Dauphin, the life of every party, for teaching me how to be a good listener. And to wear red lipstick</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04dedication.vue?14b91636